import { Button, DefaultTheme, ThemeProps } from "@deliverr/ui";
import { ModalTemplate } from "@deliverr/ui-facility";
import styled from "@emotion/styled";
import React from "react";
import { FormattedMessage } from "react-intl";

interface IProps {
  bolId: string;
  trailerId: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ButtonContainer = styled.div<{}, DefaultTheme>`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.S3};
`;

const TrailerInfoContainer = styled.div<ThemeProps>(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${theme.spacing.S2};
  margin-bottom: ${theme.spacing.S3};
  padding: ${theme.spacing.S4};
  background: ${theme.colors.NEUTRAL["05"]};
  border-radius: ${theme.border.radius.R3};
  text-align: left;
`
);

const InfoRow = styled.div`
  font-size: 1.1rem;
`;

const WarningText = styled.div<{}, DefaultTheme>`
  font-size: 0.9rem;
  font-style: italic;
  color: ${({ theme }) => theme.colors.ORANGE[500]};
  margin-top: ${({ theme }) => theme.spacing.S2};
`;

export const TrailerConfirmationModal: React.FC<IProps> = ({ bolId, trailerId, onConfirm, onCancel }) => {
  return (
    <ModalTemplate
      buttonLayout={"column"}
      title={
        <FormattedMessage
          id="sortation.trailerCloseout.trailerConfirmation.header"
          defaultMessage="Confirm Trailer ID for BOL {bolId}"
          values={{ bolId }}
        />
      }
    >
      <TrailerInfoContainer>
        <InfoRow>
          <strong>Trailer ID:</strong> {trailerId}
        </InfoRow>
        <WarningText>
          <FormattedMessage
            id="sortation.trailerCloseout.trailerConfirmation.message"
            defaultMessage="Please confirm this is the correct trailer for closeout."
          />
        </WarningText>
      </TrailerInfoContainer>

      <ButtonContainer>
        <Button block onClick={onConfirm}>
          <FormattedMessage id="sortation.trailerCloseout.trailerConfirmation.confirm" defaultMessage="Confirm" />
        </Button>
        <Button block onClick={onCancel} secondary>
          <FormattedMessage id="sortation.trailerCloseout.trailerConfirmation.cancel" defaultMessage="Cancel" />
        </Button>
      </ButtonContainer>
    </ModalTemplate>
  );
};
